export const CATEGORIES = 'categories'
export const TAB = 'tab'
export const RADIO_BUTTON = 'radiobutton'
export const CHIPS = 'chips'
export const MULTIPLY_SELECT = 'multiple_select'
export const GENERAL = 'General'
export const OPTIONS = 'options'
export const INPUT = 'input'
export const SORTING = 'sorting'
export const SELECT = 'select'
export const DAYS_ACTIVE = 'days_active'
export const PLACEMENT_DATE = 'placement_date'
export const PUBLISHING_PLATFORM = 'publishing_platform'
export const FULL_TEXT_SEARCH = 'through_all_text'
export const AD_GEO = 'ad_geo'
export const TEXT_SEARCH = 'text_search'
export const INPUT_LIST = 'input_list'
export const APPLIED_CREATIVES_FILTERS = 'appliedCreativesFilters'
export const FACEBOOK_PAGE = 'facebook_page'

export const FILTERS_PARAMS_TYPES = {
  chips: {
    data: [],
  },
  input: {
    value: '',
    data: '',
  },
  select: {
    data: '',
  },
  slider: {
    min: 0,
    max: 0,
  },
  input_list: {
    data: '',
    select: [],
  },
  date_time_picker: {
    startDate: '',
    endDate: '',
  },
  options: {
    from: 0,
    to: 0,
  },
  tab: {
    data: '',
  },
  multiple_select: {
    mode: '',
    select: [],
  },
  radiobutton: {
    data: '',
  },
}

export const FILTERS_AS_MULTI_SELECT_MAP = {
  [MULTIPLY_SELECT]: MULTIPLY_SELECT,
  [INPUT_LIST]: INPUT_LIST,
}

export const DEFAULT_FILTERS = {
  sorting: 'creation_date',
}

export const FILTERS_ADDITIONAL_OPTIONS = {
  use_blacklist: false,
}

export const FILTERS_ADDITIONAL_OPTIONS_NAMES = {
  use_blacklist: 'use_blacklist',
}

export const FILTERS_TYPE_OUTPUT_TEXT = ['select', 'tab', 'radiobutton']

export const IGNORE_FILTERS_DATA = [MULTIPLY_SELECT, INPUT]
export const FAVORITE_GROUP_ID = 'favorite_group_id'
export const DEFAULT_ACTIVE_FILTER_TYPE = 'search'
export const DEFAULT_ACTIVE_FILTER = 'general'
export const FILTERS_BOOLEANS_TYPES = ['and', 'or', 'not']
export const SEARCH_BY_TEXT_MAP = {
  link_search: 'link',
  text_search: 'text',
  title_search: 'title',
}

export const DEFAULT_FILTERS_MAP = {
  [SEARCH_BY_TEXT_MAP.text_search]: '',
  [SEARCH_BY_TEXT_MAP.link_search]: '',
  [SEARCH_BY_TEXT_MAP.title_search]: '',
}
